module.exports = __webpack_public_path__ + "media/images/carta-preliminar-cca304cd4dfce8a67e4d939bf07a36e6.svg";